import { createReducer, on } from '@ngrx/store';
import { SubscriptionState, initialSubscriptionState } from './subscription.state';
import * as SubscriptionActions from './subscription.actions';

export const subscriptionReducer = createReducer(
  initialSubscriptionState,

  // Load subscription status actions
  on(
    SubscriptionActions.loadSubscriptionStatus,
    (state): SubscriptionState => ({
      ...state,
      loading: true,
      error: null,
    })
  ),

  on(
    SubscriptionActions.loadSubscriptionStatusSuccess,
    (state, { subscription }): SubscriptionState => ({
      ...state,
      subscription,
      loading: false,
      error: null,
      // Only mark as loaded if subscription has subscriptionId (subscription is actually set up)
      loaded: !!(subscription && subscription.subscriptionId),
    })
  ),

  on(
    SubscriptionActions.loadSubscriptionStatusFailure,
    (state, { error }): SubscriptionState => ({
      ...state,
      loading: false,
      error,
      // Don't mark as loaded on failure - we need subscriptionId to be present
      loaded: false,
    })
  ),

  // Clear subscription
  on(
    SubscriptionActions.clearSubscription,
    (): SubscriptionState => ({
      ...initialSubscriptionState,
    })
  ),

  on(
    SubscriptionActions.blockSubscriptionAutoLoad,
    (state): SubscriptionState => ({
      ...state,
      autoLoadBlocked: true,
    })
  ),

  on(
    SubscriptionActions.unblockSubscriptionAutoLoad,
    (state): SubscriptionState => ({
      ...state,
      autoLoadBlocked: false,
    })
  )
);
